// Canonical lead-source list. Used by:
//   - Create-Lead modal source dropdown
//   - LeadProfile StatusBar inline source picker
//   - Any future source filter / report
//
// Stored in MongoDB as `lead.source` (free-form string for legacy compat).
// `normalizeSource()` maps legacy stored values onto a canonical label so the
// UI always displays from this list without forcing a one-time DB migration.

export const LEAD_SOURCES = [
  'Conventional Mailer',
  'VA Mailer',
  'FHA Mailer',
  'Web Lead',
  'Website',
  'Referral',
  'Facebook ad',
  'Past Client',
  'Other',
];

const LEGACY_MAP = {
  // legacy stored value (lower-case) → canonical
  'zillow': 'Web Lead',
  'web form': 'Website',
  'website form': 'Website',
  'realtor.com': 'Referral',
  'realtor referral': 'Referral',
  'open house': 'Referral',
  'past client': 'Past Client',
  'repeat client': 'Past Client',
  'facebook ad': 'Facebook ad',
  'google ad': 'Other',
  'linkedin': 'Other',
  'webinar': 'Other',
  'social media': 'Other',
  'walk-in': 'Other',
  'cold call': 'Other',
  'purchased list': 'Other',
  'direct': 'Other',
};

export function normalizeSource(raw) {
  if (!raw) return null;
  const trimmed = String(raw).trim();
  // Already canonical?
  if (LEAD_SOURCES.includes(trimmed)) return trimmed;
  // Case-insensitive canonical hit?
  const ci = LEAD_SOURCES.find((s) => s.toLowerCase() === trimmed.toLowerCase());
  if (ci) return ci;
  // Legacy mapping?
  const mapped = LEGACY_MAP[trimmed.toLowerCase()];
  if (mapped) return mapped;
  return 'Other';
}
